const COMPONENT_NAME = "z-fixed-value" ;


export default function register(){
    class FieldDefaultComponent extends HTMLElement {
        constructor() {
            super();
            if(!this.hasAttribute("z-bind")){
                this.currentModel = this.getAttribute("z-model") ;

                if(this.innerHTML.trim()){
                    return;
                }


                const modelPath = this.currentModel.split(".") ;

                const modelName = modelPath.shift() ;

                let bindPath = [] ;

                const modelDef = window.APP.schema.models.find(m => m.name === modelName) ;
                if(!modelDef){
                    throw "Model "+modelName+" is unknown" ;
                }
                let columns = modelDef.columns ;

                let field = null;
                let fieldName = modelPath.shift();
                while(fieldName){
                    bindPath.push(fieldName) ;

                    field = columns.find(m => m.name === fieldName) ;

                    if(!modelDef){
                        throw "Field "+fieldName+" is unknown" ;
                    }

                    if(field.submodel){
                        columns = field.submodel.columns ;
                    }
                    fieldName = modelPath.shift();
                }
            
                this.setAttribute("z-bind", bindPath.join(".")) ;
            }
        }

        get value(){
            return this.getAttribute("value");
        }
        set value(value){
            if(value != this.getAttribute("value") && this.updateValue){
                //someone try to set a value on this fixed value, force my value
                this.updateValue() ;
            }
        }

        static get observedAttributes() {
            return ["value"];
        }

        attributeChangedCallback(name, oldValue, newValue) {
            switch (name) {
                case 'value':
                    if(oldValue !== newValue){
                        this.dispatchEvent(new Event('change'));
                    }
                    break;
               
            }
        }
        
    }
    customElements.define(COMPONENT_NAME, FieldDefaultComponent);
}
